type AlertType = 'success' | 'error' | 'warning' | 'info';

type Props = {
  open: boolean;
  type?: AlertType;
  title?: string;
  message: string;
  confirmLabel?: string;
  onClose: () => void;
};

const TITLE_MAP: Record<AlertType, string> = {
  success: '확인',
  error: '알림',
  warning: '알림',
  info: '알림',
};

export default function OneliveAuthAlert({
  open,
  type = 'info',
  title,
  message,
  confirmLabel = '확인',
  onClose,
}: Props) {
  if (!open) return null;

  return (
    <div className="onelive-auth-alert-overlay" role="presentation" onClick={onClose}>
      <div
        className={`onelive-auth-alert onelive-auth-alert--${type}`}
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="onelive-auth-alert-title"
        aria-describedby="onelive-auth-alert-message"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="onelive-auth-alert-icon" aria-hidden="true">
          {type === 'success' ? '✓' : type === 'error' ? '!' : 'i'}
        </div>
        <h3 id="onelive-auth-alert-title" className="onelive-auth-alert-title">
          {title || TITLE_MAP[type]}
        </h3>
        <p id="onelive-auth-alert-message" className="onelive-auth-alert-message">
          {message}
        </p>
        <button type="button" className="onelive-auth-alert-btn" onClick={onClose}>
          {confirmLabel}
        </button>
      </div>
    </div>
  );
}
